import { type ReactNode } from 'react';
import './Card.css';

/**
 * Card — 지금은 `WidgetCard` · `TaskCard` · `AiActionCard` · `LinkPreviewCard` ·
 * `StaffCard` 가 각자다 (디자인 정본 D9·D10).
 *
 * ★ **`StatTile` 은 2026-09-06 에 제 폴더로 나갔다**(`../StatTile`) — 줄지어 서는 요약 타일
 *   (정본 D9-2)과 한 벌로 합치면서. 이름이 같은 물건이 둘이면 매번 고르게 된다.
 *
 * ★★ **`headless` 는 「제목만 있고 도구는 편집 중에만 보이는」 카드**다(대시보드 위젯).
 *    평소엔 내용만 보이고, 손댈 수 있을 때만 도구가 나타난다.
 */
export interface CardProps {
  title?: ReactNode;
  /** 제목 오른쪽 — 더보기·설정 같은 것. */
  tools?: ReactNode;
  /** 머리를 아예 그리지 않는다(내용이 곧 제목인 카드). */
  headless?: boolean;
  /** 안쪽 여백을 없앤다 — 표나 목록을 통째로 넣을 때. */
  flush?: boolean;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function Card({ title, tools, headless = false, flush = false, footer, children, className }: CardProps) {
  return (
    <section className={['wc-card', flush ? 'wc-card--flush' : '', className ?? ''].filter(Boolean).join(' ')}>
      {!headless && (title != null || tools != null) && (
        <div className="wc-card__head">
          {title != null && <h3 className="wc-card__title">{title}</h3>}
          {tools != null && <div className="wc-card__tools">{tools}</div>}
        </div>
      )}
      <div className="wc-card__body">{children}</div>
      {footer != null && <div className="wc-card__foot">{footer}</div>}
    </section>
  );
}
